import React, { useEffect, useMemo } from 'react'
import styles from 'components/Filters/FilterPanel/subcomponents/SubButtons/subbuttons.module.scss'
import { Dropdown, DropdownItem, Popover } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Switch from 'components/Switch'

const Selector = ({ filterManager, filterKey, breakpoints }) => {
  const { t } = useTranslation()
  const { filters, configuration, updateFilter } = filterManager
  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()

  const popoverState = usePopupState({
    variant: 'popover',
    id: 'selector-popover-' + filterKey,
    breakpoints: {
      0: {
        variant: 'bottomSheet',
        hasBackdrop: true,
      },
      960: {
        variant: 'popover',
        hasBackdrop: false,
      },
    },
  })

  const value = useMemo(
    () =>
      t(configuration?.[filterKey]?.optionLabelPrefix + filters?.[filterKey]),
    [filters, t],
  )

  useEffect(() => {
    !breakpoints.md && popoverState.close()
  }, [breakpoints])

  return (
    <>
      <div
        className={styles['subbuttons-filter']}
        key={'applied-filter-' + filterKey}
      >
        <span {...(breakpoints.md ? bindTrigger(popoverState) : {})}>
          <span className={styles['subbuttons-filter__label']}>
            {t(configuration[filterKey].label)}:
          </span>
          {value}
        </span>
      </div>

      <Popover
        {...bindPopover(popoverState)}
        hasBackdrop
        bodyClassName={styles['subbuttons-filter__popover-inner-switcher']}
      >
        <Dropdown>
          <DropdownItem noHover>
            <Switch
              label={t(configuration[filterKey].label)}
              checked={filterManager.filters[filterKey]}
              onChange={() => {
                updateFilter({
                  fieldName: filterKey,
                  value: !filterManager.filters[filterKey],
                })
              }}
            />
          </DropdownItem>
        </Dropdown>
      </Popover>
    </>
  )
}

Selector.propTypes = {
  filterManager: PropTypes.object,
  filterKey: PropTypes.string,
  breakpoints: PropTypes.object,
}

export default Selector
